import { useCallback } from "react"
import { CommentsEvents } from "../const/events"
import { API, Endpoints, LikeAPI, LikeObject, LikeStatisticsAPI } from "@brg/api"
import { useDispatch } from "react-redux"
import chatSlice from "shared/reducers/ChatSlice"
import { useModal } from "core"
import { IPost } from "../const/types"
import { useTranslation } from "react-i18next"
import { useAuth, useFingerprintId, useProfile } from "@brg/auth"
import { COMMENT_EDIT_MODE } from "../const/const"

export const useGetCommentsHandlers = (onUpdateData?: () => void): CommentsEvents => {
    const dispatch = useDispatch();
    const modal = useModal();
    const profile = useProfile();
    const auth = useAuth();
    const { i18n } = useTranslation();
    const fingerprintId = useFingerprintId();

    const onDelete = useCallback(async(id: string) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url('/api/comment/Delete')
        .addQuery('id', id)
        .post()
        .send()
        .then((r) => r)
    } , [])

    const onReport = useCallback((id: string) => {
        modal.show('report', {
            entityId: id,
            entityType: "comment",
            handleClose: () => {
              modal.hide();
            }
          });
    } , [modal])

    const onEdit = useCallback(async(data: IPost) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url(`/api/comment/Edit`)
        .body(data)
        .post()
        .send()
        .then((r) => r)
    } , [])

    const onAdd = useCallback(async(data: any) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url(`/api/comment/Add`)
        .body(data)
        .post()
        .send()
        .then((r) => r)
    } , [])

    const onGetComment = useCallback(async(postId: string, entityType: string) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url(`/api/comment/GetByEntity`)
        .addQuery('entityId', postId)
        .addQuery('entityType', entityType)
        .get()
        .sendJson()
    } , [])

    const onGetCommentByParentId = useCallback(async(postId: string, parentId: string, entityType: string) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url(`/api/comment/GetByEntity`)
        .addQuery('entityId', postId)
        .addQuery('entityType', entityType)
        .addQuery('parentId', parentId)
        .get()
        .sendJson()
    } , [])

    const onGetLike = useCallback(async({ entityId, entityType}: { entityId: string, entityType: string}) => {
        if (fingerprintId && entityId && entityType) {
            return await LikeStatisticsAPI.GetLikeStatistics(
                {entityId: entityId, entityType: entityType})
                .then((v: any) => v.json())
                .then((response: any) => {
                    return response
                })
                .catch((reason) => {
                    console.error(reason);
                });
        }
    }, [fingerprintId]);

    const onLike = useCallback(async({ entityId, entityType}: { entityId: string, entityType: string}) => {
        if (fingerprintId && entityId && entityType) {
            return await LikeAPI.LikeV2({entityId, entityType})
            .then((value: any) => value.json())
            .then(async (v: any) => {
                if (v) {
                    return v;
                }

                throw new Error
            })
        } else {
            auth.login();
        }

    } , [fingerprintId])


    return {
        onReport,
        onDelete,
        onEdit,
        onAdd,
        onLike,
        onGetLike,
        onGetComment,
        onGetCommentByParentId
    }
}import { useCallback } from "react"
import { CommentsEvents } from "../const/events"
import { API, Endpoints, LikeAPI, LikeObject, LikeStatisticsAPI } from "@brg/api"
import { useDispatch } from "react-redux"
import chatSlice from "shared/reducers/ChatSlice"
import { useModal } from "core"
import { IPost } from "../const/types"
import { useTranslation } from "react-i18next"
import { useAuth, useFingerprintId, useProfile } from "@brg/auth"
import { COMMENT_EDIT_MODE } from "../const/const"

export const useGetCommentsHandlers = (onUpdateData?: () => void): CommentsEvents => {
    const dispatch = useDispatch();
    const modal = useModal();
    const profile = useProfile();
    const auth = useAuth();
    const { i18n } = useTranslation();
    const fingerprintId = useFingerprintId();

    const onDelete = useCallback(async(id: string) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url('/api/comment/Delete')
        .addQuery('id', id)
        .post()
        .send()
        .then((r) => r)
    } , [])

    const onReport = useCallback((id: string) => {
        modal.show('report', {
            entityId: id,
            entityType: "comment",
            handleClose: () => {
              modal.hide();
            }
          });
    } , [modal])

    const onEdit = useCallback(async(data: IPost) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url(`/api/comment/Edit`)
        .body(data)
        .post()
        .send()
        .then((r) => r)
    } , [])

    const onAdd = useCallback(async(data: any) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url(`/api/comment/Add`)
        .body(data)
        .post()
        .send()
        .then((r) => r)
    } , [])

    const onGetComment = useCallback(async(postId: string, entityType: string) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url(`/api/comment/GetByEntity`)
        .addQuery('entityId', postId)
        .addQuery('entityType', entityType)
        .get()
        .sendJson()
    } , [])

    const onGetCommentByParentId = useCallback(async(postId: string, parentId: string, entityType: string) => {
        return await API.request()
        .endpoint(Endpoints.message)
        .url(`/api/comment/GetByEntity`)
        .addQuery('entityId', postId)
        .addQuery('entityType', entityType)
        .addQuery('parentId', parentId)
        .get()
        .sendJson()
    } , [])

    const onGetLike = useCallback(async({ entityId, entityType}: { entityId: string, entityType: string}) => {
        if (fingerprintId && entityId && entityType) {
            return await LikeStatisticsAPI.GetLikeStatistics(
                {entityId: entityId, entityType: entityType})
                .then((v: any) => v.json())
                .then((response: any) => {
                    return response
                })
                .catch((reason) => {
                    console.error(reason);
                });
        }
    }, [fingerprintId]);

    const onLike = useCallback(async({ entityId, entityType}: { entityId: string, entityType: string}) => {
        if (fingerprintId && entityId && entityType) {
            return await LikeAPI.LikeV2({entityId, entityType})
            .then((value: any) => value.json())
            .then(async (v: any) => {
                if (v) {
                    return v;
                }

                throw new Error
            })
        } else {
            auth.login();
        }

    } , [fingerprintId])


    return {
        onReport,
        onDelete,
        onEdit,
        onAdd,
        onLike,
        onGetLike,
        onGetComment,
        onGetCommentByParentId
    }
}